import { makeStyles } from "@mui/styles";
import { appTheme } from "../../theme";

// css style
export const useStyles = makeStyles({
    '@global': {
      "& .MuiOutlinedInput-root": {
        "& fieldset": {
          borderColor: " rgba(0, 0, 0, 0.2)",
        },
        "&:hover fieldset": {
          borderColor: "#006BD7",
        },
        "&.Mui-focused":{
          "&.MuiOutlinedInput-notchedOutline":{
            borderColor: "#006BD7",
          }
        },
        "&.Mui-focused fieldset": {
          borderColor: "#006BD7",
        },
      },
    },
    root: {
      height: 'calc(100vh - 72px)',
      overflow: 'auto',
      "& .MuiOutlinedInput-root": {
        "& fieldset": {
          borderColor: " rgba(0, 0, 0, 0.2)",
        },
        "&:hover fieldset": {
          borderColor: "#006BD7",
        },
        "&.Mui-focused fieldset": {
          borderColor: "#006BD7",
        },
      },
    },
    formLabel:{
      textAlign: "left",
      marginTop : '0.5rem',
      display: 'flex',
      flexDirection:'row',
      justifyContent:'flex-start',
      alignItems: 'flex-start',
    },
    radioGroupBox:{
      borderRadius: "0.5rem",
      width: "100%",
      backgroundColor:'white'
    },
    scrollableControl : {
      // height: 400,
      overflowY: "scroll",
      paddingBottom: '40px',
        [appTheme.breakpoints.down('lg')]: {
          height: "auto",
          paddingBottom: '0'
        },
    },
    progressBarSpacing: {
      paddingTop: "24px", 
    },
    dropdown:{
      width:"85%",
      whiteSpace: 'normal',
      [appTheme.breakpoints.down('md')]: {
        width:"100%",
      },
    },
    dropdownSelect:{
      textAlign: "left",
      marginLeft:'-0.65rem',
      whiteSpace: 'normal',
      anchorOrigin:'bottom',
      "*::-webkit-scrollbar": {
        width: "1rem",
      },
      "*::-webkit-scrollbar-track": {
        "-webkit-box-shadow": "inset 0 0 6px rgba(0,0,0,0.00)",
      },
      "*::-webkit-scrollbar-thumb": {
        backgroundColor: "rgba(0,0,0,.1)",
        outline: "1px solid slategrey",
      },
      [appTheme.breakpoints.down('md')]: {
        marginLeft:'0',
      },
    },
  });
  